import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfAppCategoryChartAllTimeAverageApplicationService } from '../../../core/application/services/app-category-metrics/get-self-app-category-chart-all-time-average.application-service';
import { SelfAppCategoryChartAllTimeAverageAggregateRoot } from '../../../core/domain/aggregates/app-category-metrics/self-app-category-chart-all-time-average.aggregate-root';
import { GetSelfAppCategoryChartAllTimeAverageRequestDto } from '../../dtos/app-category-metrics/get-self-app-category-chart-all-time-average.request.dto';

export class GetSelfAppCategoryChartAllTimeAveragesQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfAppCategoryChartAllTimeAverageApplicationService
  ) {}

  async execute(
    props: GetSelfAppCategoryChartAllTimeAverageRequestDto
  ): Promise<SelfAppCategoryChartAllTimeAverageAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new Error(
        `GetSelfAppCategoryChartAllTimeAveragesQuery.execute encountered an error ${error}`
      );
    }
  }
}
